export default class RequestsHistory {
    constructor() {
        this.stack = [];
    }

    push(request) {
        this.stack.push(request);
    }

    purge() {
        if (this.stack.length > 0) {
            this.stack.forEach(request => request.cancel && request.cancel());
            this.stack = [];
        }
    }
}
